import { CloseMobile } from '@/icons/index';

import Video from '../Video/Video';

import styles from './VideoModal.module.scss';

const VideoModal = ({ videoId, onClose }) => {
  return (
    !!videoId && (
      <div
        className={styles.video}
        itemScope
        itemType='http://schema.org/CreativeWork'
      >
        <div className={styles.videoContent}>
          <div className={styles.close} onClick={onClose}>
            <CloseMobile />
          </div>
          <Video
            className={styles.videoItem}
            video={{
              preview: videoId,
              videoId,
            }}
          />
        </div>
      </div>
    )
  );
};

export default VideoModal;
